import React from 'react';
import { Container } from './styles';

// import smileImage from '~/assets/tv/november-2025/6.jpg';
import smileImage from '~/assets/tv/change-your-smile/TV6.png'; // TODO: placeholder, trocar pela imagem de novembro

interface IChangeYourSmile6Props {
  show: boolean;
  startAnim: boolean;
}

const ChangeYourSmile6: React.FC<IChangeYourSmile6Props> = ({
  show,
  startAnim,
}) => {
  return (
    <Container show={show} startAnim={startAnim}>
      <img className="bg" src={smileImage} alt="chega de esconder o Sorriso" />
    </Container>
  );
};

export default ChangeYourSmile6;
